//NOTE: KEEP IN SYNC WITH API
//OWNER Types
export const TYPE_OWNER_WELCOME = "TYPE_OWNER_WELCOME";
export const TYPE_OWNER_BOOKING_REQUEST = "TYPE_OWNER_BOOKING_REQUEST";
export const TYPE_OWNER_BOOKING_CONFIRM = "TYPE_OWNER_BOOKING_CONFIRM";
export const TYPE_OWNER_BOOKING_APPROVED_FAILURE = "TYPE_OWNER_BOOKING_APPROVED_FAILURE";
export const TYPE_OWNER_BOOKING_ONEWEEK = "TYPE_OWNER_BOOKING_ONEWEEK";
export const TYPE_OWNER_BOOKING_ONEDAY = "TYPE_OWNER_BOOKING_ONEDAY";
export const TYPE_OWNER_BOOKING_CHECKOUT = "TYPE_OWNER_BOOKING_CHECKOUT";
export const TYPE_OWNER_BOOKING_CANCEL = "TYPE_OWNER_BOOKING_CANCEL";

//RENTER Types
export const TYPE_RENTER_WELCOME = "TYPE_RENTER_WELCOME";
export const TYPE_RENTER_BOOKING_APPROVED_FAILURE = "TYPE_RENTER_BOOKING_APPROVED_FAILURE";
export const TYPE_RENTER_BOOKING_APPROVED_SUCCESS = "TYPE_RENTER_BOOKING_APPROVED_SUCCESS";
export const TYPE_RENTER_BOOKING_DENIED = "TYPE_RENTER_BOOKING_DENIED";
export const TYPE_RENTER_BOOKING_CONFIRM = "TYPE_RENTER_BOOKING_CONFIRM";
export const TYPE_RENTER_BOOKING_ONEWEEK = "TYPE_RENTER_BOOKING_ONEWEEK";
export const TYPE_RENTER_BOOKING_ONEDAY = "TYPE_RENTER_BOOKING_ONEDAY";
export const TYPE_RENTER_BOOKING_CHECKOUT = "TYPE_RENTER_BOOKING_CHECKOUT";
export const TYPE_RENTER_BOOKING_CANCEL = "TYPE_RENTER_BOOKING_CANCEL";
export const TYPE_RENTER_BOOKING_DISPUTE = "TYPE_RENTER_BOOKING_DISPUTE";
export const TYPE_RENTER_BOOKING_DEPOSIT_ERROR = "TYPE_RENTER_BOOKING_DEPOSIT_ERROR";

//BOTH Types
export const TYPE_NEW_MESSAGE = "TYPE_NEW_MESSAGE";

//Notification Levels
export const LEVEL_URGENT = 0;
export const LEVEL_HIGH = 5;
export const LEVEL_NORMAL = 10;

export function getLevelForType(type) {
  switch (type) {
    case TYPE_OWNER_BOOKING_REQUEST:
    case TYPE_RENTER_BOOKING_APPROVED_FAILURE:
    case TYPE_RENTER_BOOKING_DEPOSIT_ERROR:
      return LEVEL_URGENT;
    default:
      return LEVEL_NORMAL;
  }
}

//Notification Type
export function isNotificationTypeValid(notificationType, userType) {
  if (!userType || notificationType === TYPE_NEW_MESSAGE) { return true; }
  else if (userType === "renter") {
    return notificationType.indexOf("RENTER") > -1;
  } else if (userType === "owner") {
    return notificationType.indexOf("OWNER") > -1;
  }
  return true;
}
